
import { Vue, Component } from 'vue-property-decorator';
import { customStyleKeys, toCssVariable } from '@/util/customStyle';

@Component
export default class Root extends Vue {
  // カスタマイズ対象のCSS変数を定義
  public get customStyleVariables() {
    return customStyleKeys.reduce((acc, key) => {
      acc[toCssVariable(key)] = this.$store.state.style[key];
      return acc;
    }, {} as { [key: string]: string | null });
  }
}
